/* eslint-disable object-curly-newline */

export default {
  setProviders(state, providers) {
    state.providers = providers;
  },

  setProvider(state, provider) {
    state.provider = provider;
  },

  setFilters(state, { attributes, countries, regions }) {
    state.filters = { attributes, countries, regions };
  },

  resetState(state) {
    state.provider = null
  },
};
